import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import GroupList from '../entities/group'
import appconst from '@/lib/appconst';


interface GroupListState extends ListState<GroupList> {
    editGroup: GroupList,
}

class FontOrderMutations extends ListMutations<GroupList>{

}
class GroupModule extends ListModule<GroupListState, any, GroupList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<GroupList>(),
        loading: false,
        editGroup: new GroupList(),
        orderStatus: null,
    }
    actions = {
        async getAll(context: ActionContext<GroupListState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackGroup/GetAllList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<GroupList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async deleteGroup(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackGroup/DeleteGroup?groupId=' + payload.data.groupId);
        },
        async updateGroup(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackGroup/UpdateGroupName', payload.data);
            return rep.data.result;
        },
        async addGroup(state: any, payload: any) {
            let rep= await Ajax.post('/api/services/app/BackGroup/AddGroup', payload.data);
            return rep.data.result;
        },
    };
    mutations = {
        setCurrentPage(state: GroupListState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: GroupListState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: GroupListState, group: GroupList) {
            state.editGroup = group;
        }
    }
}

const groupModule = new GroupModule();
export default groupModule;